import Vue from "vue";
import VueRouter from "vue-router";
import Index from "../views/index/index.vue";
const Login = () => import("../views/login/index.vue");
const Developer = () => import("../views/developer/index.vue");
const Laboratory = () => import("../views/laboratory/index.vue");
const Software = () => import("../views/cooperationcase/software.vue");
const Traffic = () => import("../views/cooperationcase/traffic.vue");
const Union = () => import("../views/cooperationcase/union.vue");
const Emulation = () => import("../views/terrace/emulation.vue");
const Course = () => import("../views/terrace/course.vue");
const News = () => import("../views/news/index.vue");
const NewsDetails = () => import("../views/news/details.vue");
const IndustrialEcology = () => import("../views/industrialEcology/index.vue");
const Managestandard = () => import("../views/about/managestandard.vue");
const Datastandard = () => import("../views/about/datastandard.vue");
const Disclaimer = () => import("../views/about/disclaimer.vue");
const NotFound = () => import("../views/errorPage/404.vue");
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Index
  },
  {
    path: "/Login",
    component: Login
  },
  {
    path: "/developer",
    component: Developer
  },
  {
    path: "/software",
    component: Software
  },
  {
    path: "/traffic",
    component: Traffic
  },
  {
    path: "/union",
    component: Union
  },
  {
    path: "/laboratory",
    component: Laboratory
  },
  {
    path: "/emulation",
    component: Emulation
  },
  {
    path: "/course",
    component: Course
  },
  {
    path: "/news",
    component: News
  },
  {
    path: "/newsDetails/:id",
    component: NewsDetails
  },
  {
    path: "/industrialEcology",
    component: IndustrialEcology
  },
  {
    path: "/managestandard",
    component: Managestandard
  },
  {
    path: "/datastandard",
    component: Datastandard
  },
  {
    path: "/disclaimer",
    component: Disclaimer
  },
  {
    path: "*",
    redirect: "/404"
  },
  {
    path: "/404",
    component: NotFound
  }
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes
});

export default router;
